module.exports = __webpack_public_path__ + "assets/img/assistant-zszq.5a6533d9.png";